<template>
  <div>
    <h2 class="text-center mt-0 pt-4" style="border-bottom: 2px solid;">Social Media</h2>
    <div class="row">
      <div class="col-md-4 col-11 pl-5 form-group">
        <select v-model="socialMediaType" class="form-control mb-3">
          <option value="0" disabled>Select Media</option>
          <option value="fb">Facebook</option>
          <option value="google">Google</option>
          <option value="instra">Instagram</option>
          <option value="twitter">Twitter</option>
          <option value="linkedin">Linkedin</option>
        </select>
        <label for="socialMedia">Link</label>
        <input type="text" v-model="socialMediaUrl" class="form-control" id="socialMedia" placeholder="Social media URL">
      </div>
      <div class="col-md-7 col-11 pl-5 form-group">
        <div v-for="(item, index) in socialMedia" :key="index">
          <h4 class="my-0">{{ item.type }}
            <span @click="socialMedia.splice(index, 1)" class="removeSocialBtn">x</span>
          </h4>
          <p style="word-break: break-all">{{ item.link }}</p>
        </div>
      </div>
    </div>
    <div class="col-md-12 p-5 contentBtnAlign">
      <button class="btn submitBtn" @click="updateWebConfig">Upload</button>
      <img v-if="showWebConfigLoading" src="/img/loading.gif" alt="GIF" width="30" height="30">
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapMutations } from 'vuex'

export default {
  props: ['webConfig', 'requestHeader'],
  data() {
    return {
      socialMedia: [],
      socialMediaType: '0',
      socialMediaUrl: '',
      showWebConfigLoading: false
    }
  },
  mounted() {
    if (typeof this.webConfig.socialMedia !== 'undefined') {
      this.socialMedia = this.webConfig.socialMedia
    }
  },
  methods: {
    ...mapMutations(['setRestaurantWebConfig']),

    updateWebConfig(){
      //social media payload
      this.showWebConfigLoading = true
      if (this.socialMediaType !== '0') {
        let isUpdate = false
        this.socialMedia.forEach(item => {
          if (item.type === this.socialMediaType) {
            item.link = this.socialMediaUrl
            isUpdate = true
          }
        })
        if (!isUpdate) {
          const data =
            {
              "type": this.socialMediaType,
              "link": this.socialMediaUrl
            }
          this.socialMedia.push(data)
        }
      }
      let dataToSubmit = this.webConfig
      dataToSubmit.socialMedia = this.socialMedia

      let url = process.env.VUE_APP_API_URL+'/api/webConfig/update'

      axios
        .post(url, dataToSubmit, {
          headers: this.requestHeader
        })
        .then((data) => {
          if (data.status == 200) {
            this.showWebConfigLoading = false
            this.$toastr.s("Successfully Updated.", "Success");
            this.setRestaurantWebConfig(data.data)
          }
        })
    },
  }
}
</script>
<style scoped>
.removeSocialBtn{
  color: red;
  cursor: pointer;
}
</style>
